
export const selectChartData = (list, label, value, formater, limit) => {

    var data = {
        labels: [],
        data: []
    }

    if (!list || list.length == 0) return data

    const max = list.length > limit ? limit : list.length

    for (let i = 0; i < max; i++) {
        const item = list[i];
        data.labels.push(item[label])
        data.data.push(formater ? formater(item[value]) : item[value])
    }
    return data

}




// WEBPACK FOOTER //
// ./src/common/helpers/selector.js